// "Simulating…" overlay for the results column.
//
// A translucent, lightly-blurred scrim over the results with the BEAMM
// brand glyph (the same loading mark the static site uses, animated via the
// SVG's own SMIL colour-sweep) and a caption. role="status" + aria-live
// means assistive tech announces the processing state when it appears.
//
// Shown/hidden by the `isSimulating` store flag (state/simulating_signal.ts).
// Rendered only while active so a settled page has no stray element.

const LOGO_ANIMATED = "static/images/beamm_loader.svg";
const LOGO_STATIC = "static/images/beamm_loader_static.svg";

function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export function SimulatingOverlay({
  active,
}: {
  active: boolean;
}): JSX.Element | null {
  if (!active) return null;

  // SMIL animation can't be gated by a CSS media query, so swap to a
  // static, single-colour glyph when reduced motion is requested.
  const logoSrc = prefersReducedMotion() ? LOGO_STATIC : LOGO_ANIMATED;

  return (
    <div
      className="beamm-simulating-overlay"
      data-testid="simulating-overlay"
      role="status"
      aria-live="polite"
    >
      <img
        className="beamm-simulating-logo"
        src={logoSrc}
        alt=""
        aria-hidden="true"
        width={72}
        height={56}
      />
      <p className="beamm-simulating-caption">Simulating…</p>
    </div>
  );
}
